import routerOptions0 from "/data/gitlab-runner/builds/vxUBjD1hN/1/spilnu/frontend/happytiger/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}